import { Injectable, Inject, DOCUMENT } from '@angular/core';


/**
 * This service looks for a hash in the URL and if found scrolls there automatically
 */
@Injectable()
export class ScrollOnLoadService {
    constructor(@Inject(DOCUMENT) private document: any) {}

    public scrollOnLoad(): void {
        const hash = /[^#]*$/.exec(window.location.href).toString();
        // console.log('[hash]', hash);
        let hashIdElement = this.document.getElementById(hash);
        if (hashIdElement == null) {
            hashIdElement = this.document.querySelector(`[data-id="${hash}"]`);
        }
        const element: HTMLElement = hash ? hashIdElement : null;
        if (element) {
            element.scrollIntoView();
            if (window && window.scrollBy) {
                window.scrollBy(0, -48);
            }
        }
    }
}
